import { SET_CART, SET_CART_DATA } from "../actions";

// Function to safely get data from localStorage
const getCartIds = () => {
    try {
        const data = localStorage.getItem("cartIds");
        return Array.isArray(JSON.parse(data)) ? JSON.parse(data) : [];
    } catch (error) {
        console.error("Error parsing cartIds from localStorage:", error);
        return [];
    }
};

const getCartDatas = () => {
    try {
        const data = localStorage.getItem("cartDatas");
        return Array.isArray(JSON.parse(data)) ? JSON.parse(data) : [];
    } catch (error) {
        console.error("Error parsing cartDatas from localStorage:", error);
        return [];
    }
};

const initialState = {
    cartIds: getCartIds(),
    cartDatas: getCartDatas(),
};

const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CART: {
            //const { locationId, cartId } = action.payload;

            // if (!locationId || !cartId) {
            //     console.error("Invalid SET_CART payload:", action.payload);
            //     return state;
            // }

            // Ensure cartIds is an array
            //const updatedCartIds = state.cartIds.filter(cart => cart.locationId !== locationId);

            // Add new cart entry
            //updatedCartIds.push({ locationId, cartId });

            // Update localStorage
            //localStorage.setItem("cartIds", JSON.stringify(updatedCartIds));

            return {
                ...state,
                //cartIds: updatedCartIds
            };
        }

        case SET_CART_DATA: {
            //const { cartId, cartData } = action.payload;

            // if (!cartId || !cartData) {
            //     console.error("Invalid SET_CART_DATA payload:", action.payload);
            //     return state;
            // }

            // Ensure cartDatas is an array
            //const updatedCartDatas = state.cartDatas.filter(cart => cart.cartId !== cartId);

            // Add new cart data entry
            //updatedCartDatas.push({ cartId, cartData });

            // Update localStorage
            // const totalLines = updatedCartDatas.reduce((count, cart) => {
            //     if (cart.cartData?.lines?.length) {
            //         return count + cart.cartData.lines.length;
            //     }
            //     return count;
            // }, 0);
            
            //localStorage.setItem("cartCount", totalLines);
            //localStorage.setItem("cartDatas", JSON.stringify(updatedCartDatas));

            return {
                ...state,
                //cartDatas: updatedCartDatas
            };
        }

        default:
            return state;
    }
};

export default cartReducer;
